'use strict';

function isPlainObject(object) {
    if (typeof object !== 'object') {
        return false;
    }
    if (object == null) {
        return false;
    }
    if (Object.getPrototypeOf(object) === null) {
        return true;
    }
    if (object.toString() !== '[object Object]') {
        return false;
    }
    let proto = object;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(object) === proto;
}

function isPrimitive(value) {
    return value == null || (typeof value !== 'object' && typeof value !== 'function');
}

function isTypedArray(x) {
    return (x instanceof Uint8Array ||
        x instanceof Uint8ClampedArray ||
        x instanceof Uint16Array ||
        x instanceof Uint32Array ||
        x instanceof BigUint64Array ||
        x instanceof Int8Array ||
        x instanceof Int16Array ||
        x instanceof Int32Array ||
        x instanceof BigInt64Array ||
        x instanceof Float32Array ||
        x instanceof Float64Array);
}

exports.isPlainObject = isPlainObject;
exports.isPrimitive = isPrimitive;
exports.isTypedArray = isTypedArray;
